var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "customer",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17741",
    "data-name": "Rectangle 17741",
    width: 26,
    height: 22
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20399",
    "data-name": "Group 20399",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37275",
    "data-name": "Path 37275",
    d: "M0,63.924c.039-.149.075-.3.117-.448a3.424,3.424,0,0,1,3.272-2.458,12,12,0,0,1,1.873.066,3.262,3.262,0,0,1,2.35,1.6c.043.07.083.143.125.214,0,.006.013.008.011.007.368-.29.718-.6,1.1-.86a5.864,5.864,0,0,1,3.333-1.026,20.536,20.536,0,0,1,2.581.1,5.739,5.739,0,0,1,3.28,1.639c.059.056.119.11.2.181a3.5,3.5,0,0,1,1.144-1.314,3.341,3.341,0,0,1,1.948-.607,11.432,11.432,0,0,1,2.019.1A3.276,3.276,0,0,1,25.994,64.3c.01,1.784.006,3.568,0,5.351a1.512,1.512,0,0,1-1.58,1.523c-1.422,0-2.843,0-4.265,0h-.29c-.026.114-.045.218-.074.319A1.748,1.748,0,0,1,18.12,72.75q-5.115.011-10.23,0a1.739,1.739,0,0,1-1.7-1.365c-.015-.064-.032-.127-.053-.21H1.848C.758,71.175.407,70.95,0,69.992V63.924m13,7.35h4.947c.307,0,.385-.071.386-.353,0-1.347.012-2.695,0-4.042A4.462,4.462,0,0,0,14.639,62.6a14.029,14.029,0,0,0-2.324-.105,4.544,4.544,0,0,0-4.648,4.524c0,1.282,0,2.563,0,3.845,0,.351.059.406.433.406H13M6.121,69.687a.264.264,0,0,0,.017-.048c0-.912-.025-1.825.02-2.735a15.92,15.92,0,0,1,.254-1.675,5.938,5.938,0,0,0,.13-.889,1.8,1.8,0,0,0-1.559-1.8A9.915,9.915,0,0,0,3.542,62.5a1.886,1.886,0,0,0-2.019,1.965q0,2.49,0,4.98c0,.079.007.159.012.246Zm18.353,0v-.276c0-1.725.012-3.451-.01-5.176a1.752,1.752,0,0,0-1.491-1.673A13.613,13.613,0,0,0,21,62.539a1.238,1.238,0,0,0-.455.14,1.939,1.939,0,0,0-1.029,2.371,6.453,6.453,0,0,1,.274,1.246c.053,1.041.044,2.085.06,3.128,0,.086,0,.173,0,.259Z",
    transform: "translate(0 -50.755)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37276",
    "data-name": "Path 37276",
    d: "M54.007,0a4.361,4.361,0,0,1,4.409,4.311,4.419,4.419,0,0,1-8.834-.041A4.364,4.364,0,0,1,54.007,0m2.886,4.287a2.9,2.9,0,0,0-5.788-.005,2.895,2.895,0,0,0,5.788.005",
    transform: "translate(-41.001 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37277",
    "data-name": "Path 37277",
    d: "M10.119,24.2a2.713,2.713,0,1,1,2.8-2.7,2.762,2.762,0,0,1-2.8,2.7m1.28-2.7a1.269,1.269,0,1,0-1.291,1.217A1.253,1.253,0,0,0,11.4,21.506",
    transform: "translate(-6.069 -15.622)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37278",
    "data-name": "Path 37278",
    d: "M110.606,21.5a2.793,2.793,0,1,1,2.8,2.7,2.761,2.761,0,0,1-2.8-2.7m2.789-1.244a1.233,1.233,0,1,0,1.271,1.236,1.253,1.253,0,0,0-1.271-1.236",
    transform: "translate(-91.463 -15.622)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.5d746b14af2887754ad35077ba985490.svg";
export { ForwardRef as ReactComponent };